// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highlights_highlightsSectionCards__Fu2U-, .highlights_highlightsCardHeader__7HSbC, .highlights_highlightsCardContent__jFggJ, .highlights_highlightsContent__wu7cD, .highlights_highlightsCardOrder__Rm1dm {
    gap: 8px;
}

.highlights_highlightsContent__wu7cD, .highlights_highlightsSectionCards__Fu2U- {
    flex-direction: column;
}

.highlights_highlightsContent__wu7cD, .highlights_highlightsSectionCards__Fu2U-, .highlights_highlightsCardHeader__7HSbC {
    justify-content: space-between;
}

.highlights_highlightsContent__wu7cD, .highlights_highlightsCardHeader__7HSbC, .highlights_highlightsCardOrder__Rm1dm, .highlights_highlightsCardOrderButton__pGnnx {
    align-items: center;
}

.highlights_highlightsCardHeader__7HSbC h3, .highlights_highlightsCardHeader__7HSbC span {
    font-size: clamp(14pt, 1.5vw, 16pt);
    font-weight: bolder;
}

.highlights_highlightsCardImage__ivqET, .highlights_highlightsCardImage__ivqET img, .highlights_highlightsCardOrderIcon__12P3k img {
    width: 100%;
}

.highlights_highlightsContent__wu7cD {
    margin-bottom: 20px;
}

.highlights_highlightsContent__wu7cD h2 {
    font-size: clamp(34pt, 5vw, 64pt);
    text-align: center;
}

.highlights_highlightsCardContent__jFggJ button {
    font-size: clamp(12px, 1.5vw, 16px);
}

.highlights_borderRadiusTop__zcP1r {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.highlights_highlightsSectionCards__Fu2U-{
    gap: 0;
}

.highlights_highlightsSection__8xRPZ h2 {
    color: #495E57;
}

.highlights_highlightsSection__8xRPZ {
    padding-top: 60px;
}

.highlights_highlightsCardHeader__7HSbC {
    flex-direction: column;
}

.highlights_highlightsCardHeader__7HSbC h3 {
    color: #000;
}

.highlights_highlightsCardHeader__7HSbC span {
    color: #EE9972;
    margin: 0;
}

.highlights_highlightsCard__dY2xd {
    border: 1px solid #495E57;
    box-shadow: none;
    height: 500px;
    margin-bottom: 20px;
    overflow: hidden;
    transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;
    width: 100%;
}

.highlights_highlightsCard__dY2xd:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
    transform: scale(1.01);
}

.highlights_highlightsCardImage__ivqET {
    height: 214px;
    overflow: hidden;
}

.highlights_highlightsCardImage__ivqET img {
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease-in-out;
}

.highlights_highlightsCard__dY2xd:hover .highlights_highlightsCardImage__ivqET img {
    transform: scale(1.3);
}

.highlights_highlightsCardContent__jFggJ {
    background-color: #EDEFEE;
    height: inherit;
    padding: 16px;
}

.highlights_highlightsCardContent__jFggJ p {
    height: clamp(100px, 15vw, 160px);
}

.highlights_highlightsCardContent__jFggJ button {
    background-color: transparent;
    border: none;
    border-radius: 0;
    height: auto;
    text-align: left;
    width: auto;
}

.highlights_highlightsCardOrder__Rm1dm {
    gap: 8px;
    margin-top: 0;
}

.highlights_highlightsCardOrderButton__pGnnx {
    color:#333;
    transition: color 0.3s ease-in-out;
}

.highlights_highlightsCardOrderButton__pGnnx:hover {
    color: #EE9972;
}

.highlights_highlightsCardOrderIcon__12P3k {
    width: 30px;
}

@media (min-width: 938px) {
    .highlights_highlightsContent__wu7cD, .highlights_highlightsSectionCards__Fu2U- {
        flex-direction: row;
    }

    .highlights_highlightsContent__wu7cD h2 {
    text-align: left;
}

    .highlights_highlightsCard__dY2xd {
        height: 545px;
        margin-bottom: 0;
        width: 32%;
    }

    .highlights_highlightsCardOrder__Rm1dm {
        align-items: center;
        gap: 8px;
        margin-top: 30px;
    }
}

@media (min-width: 1046px) {
    .highlights_highlightsCardHeader__7HSbC {
        align-items: center;
        flex-direction: row;
    }

    .highlights_highlightsCardContent__jFggJ {
        gap:25px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/Highlights/highlights.module.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;AACZ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mEAAmE;IACnE,WAAW;AACf;;AAEA;IACI,wCAAwC;IACxC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;IACA,gBAAgB;AACpB;;IAEI;QACI,aAAa;QACb,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,QAAQ;QACR,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,QAAQ;IACZ;AACJ","sourcesContent":[".highlightsSectionCards, .highlightsCardHeader, .highlightsCardContent, .highlightsContent, .highlightsCardOrder {\n    gap: 8px;\n}\n\n.highlightsContent, .highlightsSectionCards {\n    flex-direction: column;\n}\n\n.highlightsContent, .highlightsSectionCards, .highlightsCardHeader {\n    justify-content: space-between;\n}\n\n.highlightsContent, .highlightsCardHeader, .highlightsCardOrder, .highlightsCardOrderButton {\n    align-items: center;\n}\n\n.highlightsCardHeader h3, .highlightsCardHeader span {\n    font-size: clamp(14pt, 1.5vw, 16pt);\n    font-weight: bolder;\n}\n\n.highlightsCardImage, .highlightsCardImage img, .highlightsCardOrderIcon img {\n    width: 100%;\n}\n\n.highlightsContent {\n    margin-bottom: 20px;\n}\n\n.highlightsContent h2 {\n    font-size: clamp(34pt, 5vw, 64pt);\n    text-align: center;\n}\n\n.highlightsCardContent button {\n    font-size: clamp(12px, 1.5vw, 16px);\n}\n\n.borderRadiusTop {\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n}\n\n.highlightsSectionCards{\n    gap: 0;\n}\n\n.highlightsSection h2 {\n    color: #495E57;\n}\n\n.highlightsSection {\n    padding-top: 60px;\n}\n\n.highlightsCardHeader {\n    flex-direction: column;\n}\n\n.highlightsCardHeader h3 {\n    color: #000;\n}\n\n.highlightsCardHeader span {\n    color: #EE9972;\n    margin: 0;\n}\n\n.highlightsCard {\n    border: 1px solid #495E57;\n    box-shadow: none;\n    height: 500px;\n    margin-bottom: 20px;\n    overflow: hidden;\n    transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;\n    width: 100%;\n}\n\n.highlightsCard:hover {\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);\n    transform: scale(1.01);\n}\n\n.highlightsCardImage {\n    height: 214px;\n    overflow: hidden;\n}\n\n.highlightsCardImage img {\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.3s ease-in-out;\n}\n\n.highlightsCard:hover .highlightsCardImage img {\n    transform: scale(1.3);\n}\n\n.highlightsCardContent {\n    background-color: #EDEFEE;\n    height: inherit;\n    padding: 16px;\n}\n\n.highlightsCardContent p {\n    height: clamp(100px, 15vw, 160px);\n}\n\n.highlightsCardContent button {\n    background-color: transparent;\n    border: none;\n    border-radius: 0;\n    height: auto;\n    text-align: left;\n    width: auto;\n}\n\n.highlightsCardOrder {\n    gap: 8px;\n    margin-top: 0;\n}\n\n.highlightsCardOrderButton {\n    color:#333;\n    transition: color 0.3s ease-in-out;\n}\n\n.highlightsCardOrderButton:hover {\n    color: #EE9972;\n}\n\n.highlightsCardOrderIcon {\n    width: 30px;\n}\n\n@media (min-width: 938px) {\n    .highlightsContent, .highlightsSectionCards {\n        flex-direction: row;\n    }\n\n    .highlightsContent h2 {\n    text-align: left;\n}\n\n    .highlightsCard {\n        height: 545px;\n        margin-bottom: 0;\n        width: 32%;\n    }\n\n    .highlightsCardOrder {\n        align-items: center;\n        gap: 8px;\n        margin-top: 30px;\n    }\n}\n\n@media (min-width: 1046px) {\n    .highlightsCardHeader {\n        align-items: center;\n        flex-direction: row;\n    }\n\n    .highlightsCardContent {\n        gap:25px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highlightsSectionCards": `highlights_highlightsSectionCards__Fu2U-`,
	"highlightsCardHeader": `highlights_highlightsCardHeader__7HSbC`,
	"highlightsCardContent": `highlights_highlightsCardContent__jFggJ`,
	"highlightsContent": `highlights_highlightsContent__wu7cD`,
	"highlightsCardOrder": `highlights_highlightsCardOrder__Rm1dm`,
	"highlightsCardOrderButton": `highlights_highlightsCardOrderButton__pGnnx`,
	"highlightsCardImage": `highlights_highlightsCardImage__ivqET`,
	"highlightsCardOrderIcon": `highlights_highlightsCardOrderIcon__12P3k`,
	"borderRadiusTop": `highlights_borderRadiusTop__zcP1r`,
	"highlightsSection": `highlights_highlightsSection__8xRPZ`,
	"highlightsCard": `highlights_highlightsCard__dY2xd`
};
export default ___CSS_LOADER_EXPORT___;
